import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getSurfaceBorder, getSurfaceColor, radii } from '../tokens';

export const styledBackstageTableFiltersContainer = (
  theme: Theme,
): BackstageOverrides['BackstageTableFiltersContainer'] => ({
  root: {
    backgroundColor: getSurfaceColor(theme, 'subtle'),
    border: `1px solid ${getSurfaceBorder(theme)}`,
    borderRadius: radii.lg,
    boxShadow: 'none',
    padding: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(1.25),
  },
});
